import { useEffect, useState } from "react";
import { BaseURL } from "../../../constants/enum/baseURL.emum";
import doc3Service from "../../../services/doc3.service";
import ShowDoc from "../../common/showDoc";
import GroupChack from "./groupChack";
import ShowDoc5 from "./showDoc5";

const SendListItem = (props: { doc3: any; kpi: any[]; send: boolean }) => {
  const { doc3, kpi, send } = props;
  const [sendStatus, setSendStatus] = useState<any>([]);
  const [status, setStatus] = useState(true);

  useEffect(() => {
    (async () => {
      await doc3Service
        .checkSend(Number(doc3.schedule.id), Number(doc3.course.id))
        .then((res) => {
          setSendStatus(res.data);
          setStatus(false);
        });
    })();
  }, [doc3.course.id, doc3.schedule.id]);

  // console.log(doc3);

  if (status) return null;

  if (send) {
    if (sendStatus) {
      const sendKpi = sendStatus.kpi.split(",");
      const CKpi = sendKpi.filter((x: string) => {
        return kpi.indexOf(x) !== -1;
      });
      if (CKpi.length >= 1) {
        return (
          <tr key={doc3.id}>
            {/* <td scope="col">{doc3.course.courseCode}</td>
            <td scope="col">{doc3.course.name}</td>
            <td scope="col">{doc3.course.cradit}</td> */}
            {/* <td scope="col">{doc3.course.owner.shortName}</td>
            <td scope="col">{doc3.schedule.year}</td>
            <td scope="col">{doc3.schedule.term}</td>
            <td scope="col">{doc3.responsible}</td> */}
            <td>
              <h6>{doc3.course.courseCode}</h6>
              <div>{doc3.course.name}</div>
              <span>{doc3.course.cradit}</span>
            </td>
            {/* <td scope="col">{doc3.course.owner.shortName}</td> */}
            <td>
              {doc3.schedule.term}/{doc3.schedule.year.toString().substr(-2)}
            </td>
            {/* <td scope="col">{doc3.schedule.term}</td> */}
            <td>
              <div>
                <div>{doc3.course.owner.shortName}</div>
                <div>{doc3.responsible}</div>
              </div>
            </td>
            <td>
              <GroupChack
                schedule={doc3.schedule.id}
                course={doc3.course.id}
                type={doc3.schedule.type === "tqf" ? "มคอ." : "อชว."}
              />
            </td>

            {/* <td scope="col">
              <GroupChack schedule={doc3.schedule.id} course={doc3.course.id} type={doc3.schedule.type === "tqf" ? "มคอ." : "อชว."} />
            </td> */}
            <td>
              <ShowDoc
                btnName={`${doc3.schedule.type === "tqf" ? "มคอ." : "อชว."}3 | RMTUI-1`}
                url={`${BaseURL.BASE_URL}/upload/doc3/${sendStatus.pathFile}`}
                sendBy={sendStatus.sendBy}
              />
            </td>
            <td>
              <ShowDoc5
                doc3={sendStatus}
                type={doc3.schedule.type === "tqf" ? "มคอ." : "อชว."}
                course={doc3.course}
                schedule={doc3.schedule}
              />
            </td>
          </tr>
        );
      }
    }
    return <></>;
  } else {
    if (sendStatus)
      // เอา kpi มาเทียบกับ kpiจาก sendStatus
      return (
        <tr key={doc3.id}>
          {/* <td scope="col">{doc3.course.courseCode}</td>
          <td scope="col">{doc3.course.name}</td>
          <td scope="col">{doc3.course.cradit}</td> */}
          <td>
            <h6>{doc3.course.courseCode}</h6>
            <div>{doc3.course.name}</div>
            <span>{doc3.course.cradit}</span>
          </td>
          {/* <td scope="col">{doc3.course.owner.shortName}</td> */}
          <td>
            {doc3.schedule.term}/{doc3.schedule.year.toString().substr(-2)}
          </td>
          {/* <td scope="col">{doc3.schedule.term}</td> */}
          <td>
            <div>
              <div>{doc3.course.owner.shortName}</div>
              <div>{doc3.responsible}</div>
            </div>
          </td>
          <td>
            <GroupChack
              schedule={doc3.schedule.id}
              course={doc3.course.id}
              type={doc3.schedule.type === "tqf" ? "มคอ." : "อชว."}
            />
          </td>
          {/* <td scope="col">{sendStatus.kpi}</td> */}
          <td>
            <ShowDoc
              btnName={`${doc3.schedule.type === "tqf" ? "มคอ." : "อชว."}3 | RMTUI-1`}
              url={`${BaseURL.BASE_URL}/upload/doc3/${sendStatus.pathFile}`}
              sendBy={sendStatus.sendBy}
            />
          </td>
          <td>
            <ShowDoc5
              doc3={sendStatus}
              type={doc3.schedule.type === "tqf" ? "มคอ." : "อชว."}
              course={doc3.course}
              schedule={doc3.schedule}
            />
          </td>
        </tr>
      );
    return (
      <tr key={doc3.id}>
        {/* <td scope="col">{doc3.course.courseCode}</td>
        <td scope="col">{doc3.course.name}</td>
        <td scope="col">{doc3.course.cradit}</td> */}
        <td>
          <h6>{doc3.course.courseCode}</h6>
          <div>{doc3.course.name}</div>
          <span>{doc3.course.cradit}</span>
        </td>
        <td>
          {doc3.schedule.term}/{doc3.schedule.year.toString().substr(-2)}
        </td>
        <td>
          <div>
            <div>{doc3.course.owner.shortName}</div>
            <div>{doc3.responsible}</div>
          </div>
        </td>
        <td></td>

        <td colSpan={2}>ยังไม่ส่ง</td>
      </tr>
    );
  }
};

export default SendListItem;
